import { SECTION } from '../../../constants/hierarchy';

export const ASANA_ASSIGNEE_FIELD_ID = 'assignee';
export const ASANA_NAME_FIELD_ID = 'name';
export const ASANA_SECTION_FIELD_ID = SECTION;
export const ASANA_DESCRIPTION_FIELD_ID = 'notes';
export const ASANA_DUE_ON_FIELD_ID = 'due_on';
export const ASANA_START_DATE_FIELD_ID = 'start_on';
export const ASANA_COLLABORATORS_FIELD_ID = 'followers';
export const ASANA_LIKES_FIELD_ID = 'likes';
export const ASANA_TAGS_FIELD_ID = 'tags';
export const ASANA_CREATED_BY_FIELD_ID = 'created_by';
